import React, { useEffect, useState } from 'react';
import { MiniPlayer } from './MiniPlayer';
import { ExpandedPlayer } from './ExpandedPlayer';
import { AudioPlayerProvider } from '../context/AudioPlayerContext';
export function Layout({
  children
}) {
  const [isPlayerExpanded, setIsPlayerExpanded] = useState(false);
  return <AudioPlayerProvider data-id="element-58">
      <div className="flex flex-col h-screen bg-gray-50" data-id="element-59">
        <header className="bg-white shadow-sm p-4 flex items-center" data-id="element-60">
          <h1 className="text-2xl font-semibold text-gray-800" data-id="element-61">
            European Audio Tours
          </h1>
        </header>
        <main className="flex-1 overflow-auto" data-id="element-62">{children}</main>
        <div className={`transition-all duration-300 ${isPlayerExpanded ? 'h-[70vh]' : 'h-16'}`} data-id="element-63">
          {isPlayerExpanded ? <ExpandedPlayer onClose={() => setIsPlayerExpanded(false)} data-id="element-64" /> : <MiniPlayer onExpand={() => setIsPlayerExpanded(true)} data-id="element-65" />}
        </div>
      </div>
    </AudioPlayerProvider>;
}